import {
  VITE_DD_APPLICATION_ID,
  VITE_DD_CLIENT_TOKEN,
  VITE_ENVIRONMENT,
  VITE_MAUD_APP_VERSION,
} from '~/lib/constants/env';
import { datadogRum } from '@datadog/browser-rum';
import { isStgEnvironment, isProdEnvironment } from '../environment.util';
import { datadogLogs } from '@datadog/browser-logs';

let isDatadogInitialized = false;
const shouldMask = isProdEnvironment || isStgEnvironment;
const privacyLevel = shouldMask ? 'mask' : 'allow';

export const initDatadog = () => {
  if (isDatadogInitialized) {
    return;
  }
  try {
    // Initialize RUM
    datadogRum.init({
      allowedTracingUrls: [
        {
          match: /mixpanel\.com/,
          propagatorTypes: [],
        },
        {
          match: /https:\/\/.*\.equip\.health.*/,
          propagatorTypes: ['datadog'],
        },
      ],
      applicationId: VITE_DD_APPLICATION_ID,
      clientToken: VITE_DD_CLIENT_TOKEN,
      defaultPrivacyLevel: privacyLevel,
      env: VITE_ENVIRONMENT || 'dev',
      service: 'equip-vesta',
      sessionReplaySampleRate: 5, // 5% of sessions will have session replay
      sessionSampleRate: 100,
      site: 'datadoghq.com',
      trackLongTasks: true,
      trackResources: true,
      trackUserInteractions: true,
      version: VITE_MAUD_APP_VERSION || '1.0.0',
    });

    // Initialize Logs
    datadogLogs.init({
      clientToken: VITE_DD_CLIENT_TOKEN,
      env: VITE_ENVIRONMENT || 'dev',
      forwardErrorsToLogs: true,
      service: 'equip-vesta',
      sessionSampleRate: 100,
      site: 'datadoghq.com',
      version: VITE_MAUD_APP_VERSION || '1.0.0',
    });
    isDatadogInitialized = true;
  } catch (error) {
    console.debug('Datadog init failed', error);
  }
};
